import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const confirmAdminSensorOrder = async (orderId) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `legacy_admin/renolog/sensor-orders/${orderId}/confirm`,
    body: {},
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
